module.exports = __webpack_public_path__ + "static/48-74ad240dece1668550d26f52335b2d7c.png";